import { useCallback, useEffect, useMemo, useState } from 'react';
import { commentCooldownState } from '../utils/commentCooldown';

/**
 * Live view of the comment cooldown for one conversation: recomputes when the
 * stored entries change (a successful send shows up through the snapshot or
 * refetch, a failed one never does) and ticks once a second while blocked so
 * the remaining wait counts down. `check()` re-evaluates at call time for the
 * send handler, which must not rely on the button state alone.
 */
export function useCommentCooldown(entries, uid, isComment = null) {
  const [now, setNow] = useState(() => Date.now());
  const state = useMemo(() => commentCooldownState(entries || [], uid, now, { isComment }), [entries, uid, now, isComment]);

  useEffect(() => { setNow(Date.now()); }, [entries]);
  useEffect(() => {
    if (state.allowed) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [state.allowed]);

  const check = useCallback(() => commentCooldownState(entries || [], uid, Date.now(), { isComment }), [entries, uid, isComment]);
  return { ...state, remainingSeconds: Math.ceil(state.remainingMs / 1000), check };
}
